import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import axios from 'axios';
import {Message, Loader, MGSiteButton} from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetDepositByEcoupon';

var styles = AppSettings.styles;

class DepositByEcoupon extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            typeMessage: "error",
            message: "",
            showLoading: false
        }
        
        this.depositHandler = this.depositHandler.bind(this);
        this.refEcouponCode = React.createRef();
    }
   
    depositHandler(event){
        var code = this.refEcouponCode.current.value.trim();
        if(this.state.showLoading){
            return;
        }        

        if(code == ""){
            this.setState({
                showLoading: false,
                typeMessage: "error",
                message: "Inserisci un codice valido"
            });
            return;   
        }
        this.setState({
            showLoading: true,
            typeMessage: "",
            message: ""
        });

        var url = AppSettings['env'].urlUserBoxDeposit.ecoupon;
        var post = { ECouponCode: code, SessionToken: "" };
        var self = this;
        axios.post(url, post)
            .then(({data, status, statusText}) => {
                var message = "";
                var typeMessage = "";
                if(data.errors.length == 0){
                    typeMessage = "success";
                    let details = data.Details.Scope.toLowerCase();
                    if(details.indexOf("sportive") != -1){
                        message = "La richiesta di attivazione del coupon sportivo è in fase di elaborazione";
                    }else{
                        const regex = /coupon/i;
                        let productScope = data.Details.Scope.replace(regex, "").trim();
                        message = "Il coupon  " + productScope + " è stato attivato";
                    }
                }
                else{
                    typeMessage = "error";
                    message = data.errors[0].userMessage;
                }
       
                this.setState({
                    typeMessage: typeMessage,
                    message: message,
                    showLoading: false
                }, () =>{
                    
                    this.props.onFeedCallback(this.state);
                    if(typeMessage == "success"){
                        this.props.successCallback();
                    }
                });

            })

            .catch(function(error) {
                console.log(error);
                self.setState({
                    typeMessage: "error",
                    message: "Si è verificato un errore",
                    showLoading: false
                }, () =>{
                    this.props.onFeedCallback(this.state);
                });

            });
    }

    render(){
        // var errorComponent = "";
        // if(this.state.message != ""){
        //     errorComponent = <Message type={this.state.typeMessage}>{this.state.message}</Message>
        // }
        var disclaimerInfoBonus = <Message type="info">L’accredito dei Coupon Sport potrebbe non essere immediato poiché soggetto a limitazioni, come previsto da normativa vigente.</Message>
        return(
            <React.Fragment>
                
                <div className="mg-memobet-loader">
                    {this.state.showLoading
                    ?
                        <Loader type="circular" />       
                    :
                    (
                        <>
                            <div className="mg-input-text">      
                                <input placeholder="inserisci codice" className="mg-input-text" type="text" ref={this.refEcouponCode} defaultValue="" required/>
                                <span className="bar">
                                    <i className="left" style={styles.primaryBackgroundColor}/><i className="right" style={styles.primaryBackgroundColor}/>
                                </span>
                                <label><strong>Se hai ricevuto un codice promozionale</strong> inseriscilo qui per riscuotere il tuo Coupon.</label> 
                            </div>          
                        
                            <MGSiteButton
                                title="Carica"                
                                class="mg-user-widget--carica-codice"
                                label="Carica"
                                disabled={false}
                                primary={true}
                                isButton={true}
                                fullWidth={true}
                                actionFunc={this.depositHandler}
                            />
                            <div className="mg-coupon-loader--disclaimer">
                                {!this.state.showLoading && disclaimerInfoBonus}
                            </div>
                            {/* {errorComponent}   */}
                        </>
                    )
                    }
                </div>
            </React.Fragment>
        );
    }
}

DepositByEcoupon.displayName = componentName;

// PropTypes validation
DepositByEcoupon.propTypes = {
   successCallback: PropTypes.func,
   onFeedCallback: PropTypes.func
};

// default props
DepositByEcoupon.defaultProps = {
    successCallback: ()=>{},
    onFeedCallback: ()=>{}
};

export default DepositByEcoupon;